import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AuthService } from '../services/auth.service';
import { catchError } from 'rxjs/operators';
import { BroadcastService } from '../modules/tcm-core.module';
import { ErrorService } from '../services/system/error.service';
import { BroadCastEvents } from '../common/broad-cast-events.enum';

@Injectable({
  providedIn: 'root'
})
export class TcmHttpRequestInterceptor implements HttpInterceptor {
  constructor(private readonly authService: AuthService,
    private errorService: ErrorService,
    private broadcastService: BroadcastService) { }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const currentUser = this.authService.currentUserValue;
    if (currentUser && currentUser.token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`,
          TcmUserTimeZoneOffset: `${new Date().getTimezoneOffset()}`
        }
      });
    }

    //return next.handle(request);
    return next.handle(request)
      .pipe(catchError(err => this.processRequestError(err, request.url)));
  }

  private processRequestError(err: any, requestUrl: string) {    
    const errorText = 'TCM encountered an error.';
    this.errorService.addError(errorText);
      
    this.broadcastService.next({ name: BroadCastEvents.ServerErrorOccurred });
    
    return new Observable<HttpEvent<any>>();
  }
}
